var o = 9007199254740991, d = /^(?:0|[1-9]\d*)$/;
function f(r, s) {
  var t = typeof r;
  return s = s == null ? o : s, !!s && (t == "number" || t != "symbol" && d.test(r)) && r > -1 && r % 1 == 0 && r < s;
}
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_isIndex.js
// module id = 464
// module chunks = 67